import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemplateFilterService {

 getDefaultFilter() {
  return {
    authorIds: [] as number[],
    searchAuthor: undefined as string | undefined,
    searchTitle: '',
    searchLocation: '',
    searchStatus: [] as string[],
    searchCategory: [] as string[],
    searchOperatingTime: [] as string[],
    searchTaskType: [] as string[],
    searchOnline: undefined as boolean | undefined,
    searchStartTime: undefined as Date | undefined,
    searchEndTime: undefined as Date | undefined,
    minDuration: 1,
    maxDuration: 15,
  };
}


  filterTemplate(templates: any[], filter: any): any[] {
  const {
    authorIds, 
    searchTitle = '',
    searchLocation = '',
    searchStatus = [],
    searchCategory = [],
    searchOperatingTime = [],
    searchTaskType = [],
    searchOnline,
    searchStartTime,
    searchEndTime,
    minDuration = 1,
    maxDuration = 15,
  } = filter;

  const title = searchTitle.trim().toLowerCase();
  const location = searchLocation.trim().toLowerCase();

  return templates.filter(template => {
    const matchesTitle = title ? template.title?.toLowerCase().includes(title) : true;
    const matchesLocation = location ? template.location?.toLowerCase().includes(location) : true;
    const matchesStatus = searchStatus.length ? searchStatus.includes(template.status) : true;
    const matchesCategory = searchCategory.length ? searchCategory.includes(template.category) : true;
    const matchesOperatingTime = searchOperatingTime.length ? searchOperatingTime.includes(template.einsatzzeit) : true;
    const matchesTaskType = searchTaskType.length ? searchTaskType.includes(template.type) : true;
    const matchesOnline = searchOnline !== undefined ? template.online === (searchOnline ? 1 : 0) : true;

    const taskStart = new Date(template.start);
    const taskEnd = new Date(template.end);
    const durationInHours = Math.ceil((taskEnd.getTime() - taskStart.getTime()) / (1000 * 60 * 60));
    const matchesDuration = durationInHours >= minDuration && durationInHours <= maxDuration;
    const matchesStartTime = searchStartTime ? taskStart >= searchStartTime : true;
    const matchesEndTime = searchEndTime ? taskEnd <= searchEndTime : true;

    // 👇 Autor-Filter: prüfe, ob die authorId enthalten ist
    const matchesAuthor = authorIds?.length
      ? authorIds.includes(template.authorId)
      : true;

    return (
      matchesAuthor &&
      matchesTitle &&
      matchesLocation &&
      matchesStatus &&
      matchesCategory &&
      matchesOperatingTime &&
      matchesTaskType &&
      matchesOnline &&
      matchesStartTime &&
      matchesEndTime &&
      matchesDuration
    );
  });
}
}
